export default __webpack_public_path__ + "static/media/mentoring-service.ebaf7db3.jpg";